import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import { StepHeader, DataImportBox, SpreadsheetEditor, MontageListPrint } from './index';
import {
    LogisticsStep,
    SpreadsheetData,
    SpreadsheetColumn,
    MontageListPrintData,
    MontageListFormData,
    VehicleDropdownOption,
    MontageTeamDropdownOption,
} from '@/modules/Logistics/interfaces/LogisticsInterfaces';


export default /*#__PURE__*/_defineComponent({
  __name: 'MontageTransformator',
  props: {
    currentStep: null,
    rawData: null,
    spreadsheetData: null,
    columns: null,
    printData: null,
    isParsing: { type: Boolean },
    isEditMode: { type: Boolean },
    steps: null,
    montageTeams: null,
    vehicles: null
  },
  emits: ["update:rawData", "update:spreadsheetData", "update:printData", "data-pasted", "data-change", "form-field-update", "print-spreadsheet-change", "step-change", "print"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'update:rawData', value: string): void;
    (e: 'update:spreadsheetData', value: SpreadsheetData | null): void;
    (e: 'update:printData', value: MontageListPrintData): void;
    (e: 'data-pasted', data: string): void;
    (e: 'data-change', data: SpreadsheetData | null): void;
    (
        e: 'form-field-update',
        field: keyof MontageListFormData,
        value: MontageListFormData[keyof MontageListFormData],
    ): void;
    (e: 'print-spreadsheet-change', data: SpreadsheetData | null): void;
    (e: 'step-change', step: number): void;
    (e: 'print'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    currentStep: number;
    rawData: string;
    spreadsheetData: SpreadsheetData | null;
    columns: SpreadsheetColumn[];
    printData: MontageListPrintData;
    isParsing: boolean;
    isEditMode: boolean;
    steps: LogisticsStep[];
    montageTeams: MontageTeamDropdownOption[];
    vehicles: VehicleDropdownOption[];
};





const spreadsheetEditorRef = ref<InstanceType<typeof SpreadsheetEditor> | null>(null);
const montageListRef = ref<InstanceType<typeof MontageListPrint> | null>(null);

// Computed properties
const currentStepSubtitle = computed(() => {
    if (props.currentStep === 0) {
        if (props.spreadsheetData?.rows && Object.keys(props.spreadsheetData.rows).length > 1) {
            return `${Object.keys(props.spreadsheetData.rows).length - 1} rows ready`;
        }
        return 'Step 1 of 3';
    }
    if (props.spreadsheetData?.rows) {
        return `${Object.keys(props.spreadsheetData.rows).length - 1} rows`;
    }
    return '';
});

// Event handlers - emit to parent
function handleDataPasted(data: string) {
    emit('data-pasted', data);
}

function handleRawDataInput(value: string) {
    emit('update:rawData', value);
}

function handleDataChange(data: SpreadsheetData | null) {
    emit('data-change', data);
    emit('update:spreadsheetData', data);
}

function handleFormFieldUpdate(
    field: keyof MontageListFormData,
    value: MontageListFormData[keyof MontageListFormData],
) {
    emit('form-field-update', field, value);
}

function handlePrintSpreadsheetChange(data: SpreadsheetData | null) {
    emit('print-spreadsheet-change', data);
}

function print() {
    montageListRef.value?.print();
}

function reloadSpreadsheetData(data: SpreadsheetData) {
    spreadsheetEditorRef.value?.reloadData(data);
}

// Expose methods for parent
expose({
    print,
    reloadSpreadsheetData,
    currentStepSubtitle,
});

return { __sfc: true,props, emit, spreadsheetEditorRef, montageListRef, currentStepSubtitle, handleDataPasted, handleRawDataInput, handleDataChange, handleFormFieldUpdate, handlePrintSpreadsheetChange, print, reloadSpreadsheetData, StepHeader, DataImportBox, SpreadsheetEditor, MontageListPrint }
}

})